enum callToActionTestIds {
	ctaAnchor = 'cta-anchor',
	ctaTitle = 'cta-title',
}
export default callToActionTestIds;
